import { Loader2, Shield, ArrowLeft } from 'lucide-react';

interface OTPFormProps {
  otpCode: string;
  otpEmail: string;
  otpLoading: boolean;
  error: string | null;
  onOTPCodeChange: (code: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onRequestNewOTP: () => void;
  onBackToLogin: () => void;
}

export const OTPForm: React.FC<OTPFormProps> = ({
  otpCode,
  otpEmail,
  otpLoading,
  error,
  onOTPCodeChange,
  onSubmit,
  onRequestNewOTP,
  onBackToLogin,
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-cyan-600 px-8 py-6 text-center">
        <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <Shield className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-2xl font-bold text-white mb-2">Xác thực OTP</h1>
        <p className="text-blue-100 text-sm">
          Nhập mã OTP đã được gửi đến email của bạn
        </p>
      </div>

      {/* OTP Form */}
      <div className="p-8">
        <div className="mb-6 text-center">
          <p className="text-sm text-gray-600 mb-2">Mã OTP đã được gửi đến:</p>
          <p className="font-medium text-gray-800">{otpEmail}</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-5">
          {/* OTP Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Mã OTP
            </label>
            <div className="relative">
              <Shield className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="text"
                required
                maxLength={6}
                value={otpCode}
                onChange={(e) => onOTPCodeChange(e.target.value.replace(/\D/g, ''))}
                disabled={otpLoading}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors text-center text-lg tracking-widest"
                placeholder="000000"
              />
            </div>
          </div>

          {/* Error message */}
          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-sm text-red-600">{error}</p>
            </div>
          )}

          {/* Submit button */}
          <button
            type="submit"
            disabled={otpLoading || !otpCode || otpCode.length !== 6}
            className="w-full bg-gradient-to-r from-blue-600 to-cyan-600 text-white py-3 px-4 rounded-lg font-medium hover:from-blue-700 hover:to-cyan-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center"
          >
            {otpLoading ? (
              <>
                <Loader2 className="animate-spin w-5 h-5 mr-2" />
                Đang xác thực...
              </>
            ) : (
              'Xác thực OTP'
            )}
          </button>
        </form>

        {/* Request new OTP */}
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600 mb-2">Không nhận được mã?</p>
          <button
            onClick={onRequestNewOTP}
            disabled={otpLoading}
            className="text-blue-600 hover:text-blue-800 font-medium text-sm"
          >
            Gửi lại mã OTP
          </button>
        </div>

        {/* Back to login */}
        <div className="mt-4 text-center">
          <button
            onClick={onBackToLogin}
            disabled={otpLoading}
            className="inline-flex items-center text-gray-600 hover:text-gray-800 text-sm"
          >
            <ArrowLeft className="w-4 h-4 mr-1" />
            Quay lại đăng nhập
          </button>
        </div>
      </div>
    </div>
  );
};